import React, { useEffect, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap"
import { ChevronLeft, ChevronRight } from "react-bootstrap-icons"

export function SelectSpinner<T>(p: {
  options: T[];
  value: T;
  disabled?: boolean;
  getLabel?: (x: T) => string;
  getKey?: (x: T) => string;
  onChange: (value: T) => void;
}) {
  const [selection, setSelection] = useState(
    p.options.findIndex(next =>
      p.getKey && p.getKey?.(p.value) === p.getKey?.(next) || p.value === next
    )
  );

  useEffect(() => {
    p.onChange(p.options[selection]);
  }, [selection])

  return (
    <InputGroup>
      <Button
        variant="outline-secondary"
        disabled={p.disabled || selection <= 0}
        onClick={() =>
          setSelection(s => Math.max(s - 1, 0))
        }
      >
        <ChevronLeft />
      </Button>
      <Form.Select value={selection} disabled={p.disabled} onChange={({ target }) => {
        setSelection(parseInt(target.value))
      }}>
        {p.options.map((o, i) =>
          <option key={i} value={i}>{p.getLabel?.(o) ?? String(o)}</option>
        )}
      </Form.Select>
      <Button
        variant="outline-secondary"
        disabled={p.disabled || selection >= p.options.length - 1}
        onClick={() =>
          setSelection(s => Math.min(s + 1, p.options.length - 1))
        }
      >
        <ChevronRight />
      </Button>
    </InputGroup >
  );
}